import "./BidFilterCarousel.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

import BidNewCard from "./BidNewCard";
import PackageCardNew from "./PackageCardNew";
import VenuesCardNew from "./VenuesCardNew";

export default function VenuesFilterCarousel({ data }) {

  return (
    <div className="bid-filter-carousel-container">
      <Swiper
        modules={[Pagination]}
        spaceBetween={20}
        slidesPerView={"auto"}      
        centeredSlides={true}       
        loop={data?.length > 2}
        pagination={{
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 4,
        }}             
      >
        {data.map((item, index) => (
          <SwiperSlide key={index} className="bid-filter-swiper-slide">
            <VenuesCardNew data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
